import { useKeycloak } from "@react-keycloak/web";
import { useCallback } from "react";
import type { InspectionPhoto } from "../../api/dto/InspectionPhoto";

export const useAssetUrl = () => {
  const { keycloak } = useKeycloak();

  const getInspectionPhotoUrl = useCallback(
    (photo: InspectionPhoto) => {
      const protocol = window.location.protocol; // Gets 'http:' or 'https:'
      return photo.url.replace(/^https?:/, protocol) + `?access_token=${keycloak?.token}`;
    },
    [keycloak?.token],
  );

  return {
    getInspectionPhotoUrl,
  };
};
